module.exports = __webpack_public_path__ + "img/product_70.95a8dac.webp";